export default {
  rankOrder: {
    ariaAddOption: 'Dodaj {label} do listy rankingowej',
    ariaMoveUp: 'Przesuń {label} w górę',
    ariaMoveDown: 'Przesuń {label} w dół',
    ariaRemoveOption: 'Usuń {label} z listy rankingowej',
  },
  coe: {
    ariaDisclaimer: 'Uwaga',
    ariaQuestion: 'Pytanie',
    ariaConversationHistory: 'Historia rozmowy',
    ariaYourResponse: 'Twoja odpowiedź {number}',
    ariaFollowUpQuestion: 'Pytanie uzupełniające {number}',
    ariaResponseInput: 'Pole odpowiedzi',
    ariaRespondingTo: 'Odpowiadanie na',
    ariaSendResponse: 'Wyślij odpowiedź',
    ariaThinking: 'Myślenie'
  },
  deviceView: {
    toolbar: 'Urządzenie podglądu',
    mobile: 'Telefon',
    tablet: 'Tablet',
    desktop: 'Komputer'
  },
  header: {
    customLogoAlt: 'Logo',
    defaultLogoAlt: 'Logo QuestDIY'
  }
}
